@if (loading()) {
  <div class="nc-aside-block__loading caption on-background-alt">
    {{ 'non_conformite.aside_loading' | trans }}
  </div>
} @else if (visibleNcs().length === 0) {
  <div class="nc-aside-block__empty">
    <div class="flex-row gap-8 align-center">
      <mat-icon class="nc-aside-block__icon-header">verified</mat-icon>
      <span class="subheading-2">{{ title() }}</span>
    </div>
    <span class="caption on-background-alt">
      {{ 'non_conformite.aside_empty' | trans }}
    </span>
  </div>
} @else {
  <div class="nc-aside-block">
    <!-- Header -->
    <div class="nc-aside-block__header flex-row gap-8 align-center">
      <mat-icon class="nc-aside-block__icon-header">warning</mat-icon>
      <span class="subheading-2">{{ title() }}</span>
      @if (countLabel()) {
        <span class="caption on-background-alt ml-auto">{{ countLabel() }}</span>
      }
    </div>

    <!-- KPIs (cost summary) -->
    @if (showCostSummary()) {
      <div class="nc-aside-block__kpis flex-row gap-8 wrap">
        <div class="nc-aside-block__kpi">
          <span class="nc-aside-block__kpi-label">
            {{ 'non_conformite.aside_kpi_open' | trans }}
          </span>
          <span class="nc-aside-block__kpi-value">{{ ouvertesCount() }}</span>
        </div>
        @if (critiquesCount() > 0) {
          <div class="nc-aside-block__kpi nc-aside-block__kpi--critical">
            <span class="nc-aside-block__kpi-label">
              {{ 'non_conformite.aside_kpi_critical' | trans }}
            </span>
            <span class="nc-aside-block__kpi-value">{{ critiquesCount() }}</span>
          </div>
        }
        @if (coutTotal() > 0) {
          <div class="nc-aside-block__kpi">
            <span class="nc-aside-block__kpi-label">
              {{ 'non_conformite.aside_kpi_cost' | trans }}
            </span>
            <span class="nc-aside-block__kpi-value">
              {{ coutTotal() | number: '1.0-0' }} €
            </span>
          </div>
        }
      </div>
    }

    <!-- Liste -->
    <div class="nc-aside-block__list flex-col gap-6">
      @for (nc of displayedNcs(); track nc.id) {
        <div
          class="nc-aside-block__row flex-row gap-8 align-center"
          (click)="onOpenNc(nc)"
          data-testid="nc-aside-row"
        >
          <vl-chips
            size="tiny"
            [state]="graviteState(nc)"
            [iconLeft]="typeIcon(nc)">
            {{ graviteShort(nc) }}
          </vl-chips>
          <div class="nc-aside-block__row-main flex-col">
            <span class="caption nc-aside-block__numero">
              {{ nc.numero || ('non_conformite.aside_no_numero' | trans) }}
            </span>
            <span class="nc-aside-block__desc">{{ nc.description }}</span>
          </div>
          @if (nc.coutEstime != null && nc.coutEstime > 0) {
            <span class="caption nc-aside-block__cost">
              {{ nc.coutEstime | number: '1.0-0' }} €
            </span>
          }
        </div>
      }
    </div>

    <!-- Expand / See all -->
    <div class="nc-aside-block__actions flex-row gap-8 wrap justify-between">
      @if (hasMore()) {
        <button
          type="button"
          class="nc-aside-block__expand"
          (click)="toggleExpand()"
        >
          <mat-icon>{{ expanded() ? 'expand_less' : 'expand_more' }}</mat-icon>
          {{ expanded()
            ? ('non_conformite.aside_collapse' | trans)
            : ('non_conformite.aside_expand' | trans:{ count: visibleNcs().length - 5 }) }}
        </button>
      }
      <button
        type="button"
        class="nc-aside-block__see-all caption"
        (click)="onSeeAll()"
      >
        {{ 'non_conformite.aside_see_all' | trans }}
        <mat-icon>arrow_forward</mat-icon>
      </button>
    </div>
  </div>
}
